export const shouldPopupShown = (pathname: string) => pathname.includes('forum-rieltorov')
